// <auto-generated />
// Constantes para a lista estrutural: Vendas - Status Contrato Venda
// ATENCAO: Este arquivo serve como backup do banco de dados para itens pt-BR.
// Nao remover constantes manualmente - elas protegem a integridade dos dados.

export const VENDA_ST_CONTRATO = {
  EmDigitacao: 'VENDA_ST_CONTRATO4',
  Confirmado: 'VENDA_ST_CONTRATO1',
  Encerrado: 'VENDA_ST_CONTRATO2',
  Cancelado: 'VENDA_ST_CONTRATO3'
}
